export class ClinicNonTimedTriggerMedicationRequest {
  private Action = 'clinicnontimedtriggermedication';
  public PublicToken: string;

  constructor({ PublicToken }) {
    this.PublicToken = PublicToken;
  }
}
